import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  const toast = useToast()
  const refUserListTable = ref(null)
  const tableColumns = [
    { key: 'name', label: "Department Name", sortable: true },
    { key: 'upperCategory', label: "Upper Department", sortable: true },
    { key: 'isImported', label: "Info" },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(true)
  const departments = ref(null)


  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }


  const fetchInstructers = (ctx, callback) => {
    store
      .dispatch('apps-departments/fetchAllDepartments', {
      })
      .then(response => {
        const { data, total } = response.data
        departments.value = data
        totalUsers.value = data.length
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  fetchInstructers()

  return {
    fetchInstructers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    departments,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,


    refetchData,


  }
}
